export const RED = "#C8352B";
export const WHITE = "#F0EDE6";
export const BLACK = "#0A0908";
export const MUTED = "rgba(240,237,230,0.48)";